const names = {
  gender: 'politicianData.sex',
  parti: 'party.id',
  fnr: 'ssn',
  fornavn: 'name.givenName',
  etternavn: 'name.familyName',
  adresse: 'politicianData.address.streetAddress',
  postnr: 'politicianData.address.zipCode',
  poststed: 'politicianData.address.city',
  tlfprivat: 'phone',
  arbeidssted: 'politicianData.workPlace',
  epost: 'email',
  bankkontonummer: 'politicianData.bankAccount',
  generalInfo: 'politicianData.generalInfo',
  // stilling: 'party.role',
};

const checkDifference = (key, oldVal, newVal) => {
  if (oldVal === newVal) {
    return false;
  }
  if (newVal === undefined) {
    return false;
  }
  return {
    op: 'replace',
    path: names[key],
    // eslint-disable-next-line no-nested-ternary
    value: key !== 'gender' ? newVal : (newVal === 'Kvinne' ? 'f' : 'm'),
  };
};

export default (oldVals, newVals) => Object.keys(oldVals)
  .map((key) => {
    const oldVal = oldVals[key];
    const newVal = newVals[key];
    return checkDifference(key, oldVal, newVal);
  }).filter(item => item !== false);

export function mapUserData(map, values) {
  Object.keys(values).forEach((key) => {
    switch (key) {
      case 'gender':
        map.set(key, values[key] === 'Kvinne' ? 'f' : 'm');
        break;
      case 'parti':
        if (values[key] !== '') {
          map.set('parties', [{
            id: values[key],
          }]);
        }
        break;
      case 'fnr':
        map.set('ssn', values[key]);
        break;
      case 'fornavn':
        map.set('givenName', values[key]);
        break;
      case 'etternavn':
        map.set('familyName', values[key]);
        break;
      case 'adresse':
        map.set('streetAddress', values[key]);
        break;
      case 'postnr':
        map.set('zipCode', values[key]);
        break;
      case 'poststed':
        map.set('city', values[key]);
        break;
      case 'tlfprivat':
        map.set('phone', values[key]);
        break;
      case 'arbeidssted':
        map.set('workPlace', values[key]);
        break;
      case 'epost':
        map.set('email', values[key]);
        break;
      case 'bankkontonummer':
        map.set('bankAccount', values[key]);
        break;
      case 'generalInfo':
        map.set('generalInfo', values[key]);
        break;
      default:
        break;
    }
  });
  return map;
}
